import React, { useEffect, useState } from "react";
import Storys from "../../components/common/mobile/Storys";
import ProductCardMobile from "../../components/common/mobile/ProductCardMobile";
import ProductsMobile from "../../components/common/mobile/ProductsMobile";
import SpecialProductsMobile from "../../components/common/mobile/SpecialProductsMobile";
import { Helmet } from "react-helmet";
import ProductCardSpecialMobile from "../../components/common/mobile/ProductCardSpecialMobile";
import TimerIcon from "../../icons/TimerIcon";
import { httpReauest } from "../../utils/httpRequest";
import { useSearchParams } from "react-router-dom";
import Countdown from "react-countdown";

const Discounted = () => {
  const [vehcledata, setvehcledata] = useState();
  const [hour, sethours] = useState();
  const [show, setShow] = useState();
  const [compelete, setcompelete] = useState();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (searchParams.get("timer")) {
      setShow(true);
    }
  }, [searchParams]);

  async function getData(params) {
    await httpReauest("GET", "/vehicle/timer", {}, {}).then(({ data }) => {
      setvehcledata(data?.data?.vehicles);
      sethours(data?.data?.hour);
    });
  }

  const renderer = ({ hours, minutes, seconds, completed, days }) => {
    if (completed) {
      setcompelete(true);
      return (
        <small className=" text-[#fff] flex gap-2 font-[500] items-center">
          پایان مهلت فروش ویژه
          <TimerIcon />
        </small>
      );
    }
    return (
      <span className=" text-[#fff] flex gap-2 font-[700] items-center">
        {hours}:{minutes}:{seconds}
        <TimerIcon />
      </span>
    );
  };
  const renderer2 = ({ hours, minutes, seconds, completed, days }) => {
    if (completed) {
      setcompelete(true);

      return (
        <span className=" text-[#F42A1C] flex gap-2 font-[700] items-center">
          پایان مهلت فروش ویژه
          <img src="/time.png" alt="timeer" />
        </span>
      );
    }
    return (
      <span className=" text-[#F42A1C] flex gap-2 font-[700] items-center">
        {days}:{hours}:{minutes}:{seconds}
        <img src="/time.png" alt="timeer" />
      </span>
    );
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"مرکز خرید و فروش ماشین های سنگین"}</title>
        <meta name="description" content={""} />
        <meta name="keywords" content={""} />
        <meta name="og:description" content={""} />
        <meta name="og:title" content={"مرکز خرید و فروش ماشین های سنگین"} />
      </Helmet>{" "}
      <Storys />
      <div className="mt-7">
        <div className="flex justify-between flex-wrap">
          <p className="text-[14px] sm:text-[16px] font-bold">
            کامیون های زیر قیمت
          </p>
          {hour && <Countdown date={new Date(hour)} renderer={renderer2} />}
          <div className="w-full py-0">
            {vehcledata?.map((e, i) => (
              <ProductCardSpecialMobile
                compelete={compelete}
                data={e}
                key={i}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Discounted;
